import _$ from "1dr-utils/helpers/docReady";

let container;
let ready = false;

const getContainer = function (cb) {
  if (!ready) {
    _$(() => {
      ready = true;
      container = document.getElementById("cart");
      cb();
    });
  } else {
    cb();
  }
};

const states = {
  loading: function () {
    container.setAttribute("data-state", "loading");
  },
  ready: function () {
    container.setAttribute("data-state", "ready");
  },
};

export default {
  loading: function () {
    getContainer(states.loading);
  },

  ready: function () {
    getContainer(states.ready);
  },
};
